'use strict';

module.exports = {
    LANG: 'nl-nl',
    SIGN: 'Aanmelden',
    REGISTER: 'Aanmelden',
    QUICK_ACCESS: 'Snelle toegang met',
    SIGN_JOIN: 'Gratis Inschrijven of Aanmelden!',
    NOT_MEMBER: 'Geen Lid?',
    ALREADY_MEMBER: 'Bent u al lid van AliExpress/Alibaba?',
    SHOW_ALL: 'Tonen alle',
    HIDE: 'Verberg'
};